<template>
  <v-container
    id="usuario-produtor-form"
    fluid
    tag="section"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <validation-observer>
          <form @submit.prevent="onSubmit">
            <base-material-card
              :color="corPrimaria"
              icon="mdi-camera-account"
              :title="$t('edit-profile')"
              :app-online="appOnline"
              class="py-3 px-5"
            >
              <v-row>
                <v-col
                  cols="12"
                >
                  <tex-field-with-validation
                    v-model="produtor.username"
                    rules="required|min:5"
                    label="Username..."
                    prepend-icon="mdi-account-box-outline"
                    disabled
                  />

                  <tex-field-with-validation
                    v-model="produtor.nome"
                    rules="required|min:5"
                    label="Nome..."
                    prepend-icon="mdi-face-outline"
                    disabled
                  />

                  <tex-field-with-validation
                    :value="produtor.email"
                    rules="email"
                    label="Email..."
                    prepend-icon="mdi-email-outline"
                    @input="(value) => { produtor.email = value }"
                  />
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col
                  cols="5"
                  lg="3"
                >
                  <v-btn
                    id="btnEdt"
                    class="col-3 col-sm-8"
                    :color="corError"
                    default
                    @click="showDialog(3000, 'Tem certeza que deseja remover o cadastro?')"
                  >
                    remover cadastro
                  </v-btn>
                </v-col>
                <v-col
                  cols="5"
                  lg="3"
                >
                  <v-btn
                    id="btnEdt"
                    class="col-3 col-sm-8"
                    :color="corSecondaria"
                    default
                    min-width="180"
                    type="submit"
                  >
                    Salvar
                  </v-btn>
                </v-col>
              </v-row>
            </base-material-card>
          </form>
        </validation-observer>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
    <v-dialog
      v-model="dialog.visible"
      max-width="411"
      persistent
      @keydown.esc="dialog.visible = false"
    >
      <v-card>
        <v-card-title>
          <v-spacer />
        </v-card-title>
        <v-card-text class="text-center">
          {{ dialog.message }}
        </v-card-text>
        <v-card-text class="pb-3 pt-6 text-center">
          <v-btn
            class="mr-3"
            text
            :color="corError"
            @click="dialog.visible = false"
          >
            Não
          </v-btn>

          <v-btn
            text
            :color="corSecondaria"
            @click="reset(), dialog.visible = false"
          >
            Sim
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import Login from '../../../services/login'
  import utils from '../../../services/utils'
  import Carrinho from '../../../services/carrinhoservice'

  export default {
    name: 'EditProfileForm',
    components: {
      DashboardCoreSnackbar: () => import('../components/core/Snackbar'),
    },
    mixins: [utils],

    $_veeValidate: {
      validator: 'new',
    },

    data: vm => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      corError: localStorage.corError,
      produtor: {
        id: '',
        chaveativacao: '',
        nome: '',
        email: '',
        username: '',
        telefone: '',
        datanascimento: '',
        codigoativacao: '',
      },
      maskphone: '(##)#####-####',
      maskcpf: '###.###.###-##',
      date: '',
      dateFormatted: '',
      menuData: false,
      maskdate: '##/##/####',
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      dialog: {
        visible: false,
        message: '',
      },
      loading: true,
      cart: 0,
    }),

    mounted () {
      // this.verificaVersao()
      // this.carregaInfoSistemaOperacional()
      if (localStorage.chaveativacao && localStorage.chaveativacao !== 'undefined') {
        this.chaveativacao = localStorage.chaveativacao
        localStorage.removeItem('produtoId')
        this.carregaForm()
      } else {
        localStorage.clear()
        this.$router.push('/')
      }
    },

    methods: {
      carregaForm () {
        this.loading = true
        Login.show(this.chaveativacao).then(resposta => {
          this.produtor.nome = resposta.data.nome
          this.produtor.email = resposta.data.obj.email
          this.produtor.username = resposta.data.obj.username
          this.loading = false
          this.appOnline = true
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            // Dados do Produtor Offline =========================================v
            this.produtor.nome = localStorage.nome
            this.produtor.username = localStorage.cpf
            this.produtor.email = localStorage.email
            // Dados do Produtor Offline =========================================^
            this.appOnline = false
          } else if (e.response.data.status === 'remover') {
            localStorage.clear()
            this.$router.push('/registrar')
          } else {
            this.showSnackbar('error', 3000, e.response.data.status + ' - Erro ao carregar informações de produtor')
            this.$router.push('/')
          }
          this.loading = false
        })

        Carrinho.show(localStorage.username, localStorage.tokencontrato).then(resposta => {
          this.itensCarrinho = resposta.data.itensCarrinho
          if (this.itensCarrinho) {
            this.produtoNomes = this.itensCarrinho
            this.cart = this.produtoNomes.length
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.showSnackbar('error', 3000, e.response.data.mensagem + ' - Erro ao carregar informações')
          }
        })
      },

      onSubmit () {
        this.produtor.chaveativacao = localStorage.chaveativacao
        this.produtor.platform = localStorage.platform
        this.produtor.osname = localStorage.osname

        if (localStorage.platform && localStorage.platform !== '') {
          this.produtor.platform = localStorage.platform
        } else {
          this.produtor.platform = 'unknown'
        }

        this.salvar()
      },

      salvar () {
        if (this.produtor.email) {
          Login.atualizar(this.produtor).then(resposta => {
            this.produtor.id = resposta.data.id
            this.produtor.chaveativacao = resposta.data.chaveativacao
            this.cadastrook = true
            // Dados do Produtor =========================================v
            localStorage.nome = this.produtor.nome
            localStorage.username = this.produtor.username
            // localStorage.telefone = this.produtor.telefone
            localStorage.email = this.produtor.email
            // Dados do Produtor =========================================^
            // this.codigoativacaotemp = resposta.data.codigoativacao
            this.appOnline = true
            this.showSnackbar('success', 3000, 'Cadastro de Produtor atualizado com sucesso')
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
              this.appOnline = false
            } else {
              this.showSnackbar('error', 3000, 'Falha ao salvar o Cadastro de Produtor')
              this.$router.push('/registrar')
            }
          })
        } else {
          this.showSnackbar('error', 3000, 'Email não preenchido')
        }
      },

      salvarDadosOffline () {
        // Dados do usuario =========================================v
        localStorage.nome = this.login.nome
        localStorage.username = this.login.username
        localStorage.email = this.login.email
        // Dados do usuario =========================================^
      },

      carregarDadosOffiline () {
        if (localStorage.nome) {
          this.login.nome = localStorage.nome
        }

        if (localStorage.username) {
          this.login.username = localStorage.username
        }

        if (localStorage.email) {
          this.login.email = localStorage.email
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
      showDialog (timeout, message) {
        this.dialog.visible = true
        this.dialog.timeout = timeout
        this.dialog.message = message
      },

      // formatDate (date) {
      //   // console.log('methods.formatDate')
      //   if (!date) return null

      //   const [year, month, day] = date.split('-')
      //   return `${day}/${month}/${year}`
      // },
      // parseDate (date) {
      //   // console.log('methods.parseDate')
      //   if (!date) return null

      //   const [day, month, year] = date.split('/')
      //   return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      // },

      reset () {
        Login.desativar(localStorage.chaveativacao).then(resposta => {
          localStorage.clear()
          this.$router.push('/login')
          this.appOnline = true
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.appOnline = false
          } else {
            this.showSnackbar('error', 3000, e.response.data.errors)
          }
        })
      },
    },
  }
</script>

<style lang="sass">
  #usuario-produtor-form
    margin-top: 4em

  #btnEdt
    border-radius: 1.5rem
</style>
